import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { filterChange,
        dayChange, 
        popupChange,
		addCardsGroups,
        addAreas, 
		setProjectData,
		setItemsData,
		setItemProgress,
        setProjectUsers,
        toggleSwitch,
        loadedLevelsChange,
        setQualityProgress,
        setUserRole,
        addFeaturesGroups, 
        loadingLevelIdChange,
        addMatches,
        editCards,
        editFeaturesGroup,
        setCardsGroupsWithHistoricalObservations } from '../actions';

import { findFirstLevelIdOfStage, findFirstStageId } from '../functions/finder';

import { getProjectData, 
		getItemsData,
        getItemsProgressData,
        getCardsGroupsByLevel,
        getProjectUsers,
        getQualityProgressData,
        getUserRole, 
        getMatches,
        getAllowedProtocols, 
        getCardsGroupsWithHistoricalObservations} from '../functions/getData';
import { removeNotAllowedProtocols } from '../functions/getter';
import { createCardsFeaturesV2 } from '../functions/map/mapboxDataSource';
import { FilterActions, ToggleActions } from '../constants/constants';
import { previousMonth } from '../functions/utils';

//window.project_id
const projectId = window.project_id
//window.demo_projects
const demoProjects = window.demo_projects

class PropsManager extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            depthItems: 10
        };
    }

    async loadProject() {

        try {
            //Minimum data to work
            let projectUsers = await getProjectUsers(projectId, true);
            this.props.setProjectUsers(projectUsers);

            let userRoleData = await getUserRole();
            this.props.setUserRole(userRoleData.attributes);

            console.time('projectData took');
            let projectData = await getProjectData(projectId);
            console.timeEnd('projectData took');

            let cardsGroupsWithHistoricalObservations = await getCardsGroupsWithHistoricalObservations(projectId);
            this.props.setCardsGroupsWithHistoricalObservations(cardsGroupsWithHistoricalObservations)

            let itemsData = await getItemsData(projectId, projectData, this.state.depthItems);
            this.props.setItemsData(itemsData);

            if (window.is_demo) {
                projectData.attributes.name = window.demo_project_name;
            }

            if (!userRoleData.attributes.view_all_cards) {
                let allowedProtocols = await getAllowedProtocols();
                projectData = removeNotAllowedProtocols(projectData, allowedProtocols);
            }

            this.props.setProjectData(projectData);
            if (projectData === 'unset'){
                return
            }

            //select first stage
            const firstStageId = findFirstStageId(projectData);
            this.props.filterChange(FilterActions.STAGES, [firstStageId]);

            //select first level
            const firstLevelId = findFirstLevelIdOfStage(projectData.levels, firstStageId);
            this.props.filterChange(FilterActions.LEVELS, [firstLevelId]);

            this.handle3dBuilding();

            this.props.dayChange({
                first: projectData.days[0].id, 
                last: projectData.days[projectData.days.length - 1].id
            })
            
            //Heavy stuff
            let matches = await getMatches(projectId);
            this.props.addMatches(matches);
            
            let results = await Promise.all([ 
                getItemsProgressData(projectId),
                getQualityProgressData(projectId),
            ]);

            let itemsProgress = results[0];
			this.props.setItemProgress(itemsProgress);

            let qualityProgressData = results[1];
            this.props.setQualityProgress(qualityProgressData);

        } catch (error) {
            console.log('error en loadproject');
            console.log(error);
        }
    }

	async componentDidMount() {
		await this.loadProject()
	}

    createFeaturesGroups (cardsGroups, levelId) {
        let stageId = this.props.projectData.levels[levelId].attributes.stage_id;
        let featuresGroup = {};
        featuresGroup[levelId] = createCardsFeaturesV2(cardsGroups, this.props.projectData, stageId, levelId);
        this.props.addFeaturesGroups(featuresGroup);
    }

    handle3dBuilding() {
        if (this.props.selectedItem !== 'unset') return;
        const isDemoProject = demoProjects.includes(parseInt(projectId));
        if (isDemoProject || this.props.fullBuilding) {
            const stagesLevelsData = [];
            for (const levelData of Object.values(this.props.projectData.levels)) {
                if (this.props.stageIds.length > 0 && !this.props.stageIds.includes(levelData.attributes.stage_id)) continue;
                stagesLevelsData.push(levelData);
            }
            const orderedLevelsData = stagesLevelsData.sort((firstLevel, secondLevel) => {
                return firstLevel.attributes.height - secondLevel.attributes.height;
            });
            const levelIds = orderedLevelsData.map(levelData => levelData.id);
            this.props.filterChange(FilterActions.LEVELS, levelIds);
        }
    }

    notLevelsPendingToLoad() {
        for (const levelId of this.props.loadedLevels) {
            if (!this.props.featuresGroups.hasOwnProperty(levelId.toString())) {
                return false;
            }
        }
        return true;
    }

    async loadLevels(levelIds) {
        this.props.toggleSwitch(ToggleActions.LOADING_LEVEL, true);
        for (const levelId of levelIds) {
            this.props.loadingLevelIdChange(levelId);
            let cardsGroups = await getCardsGroupsByLevel(projectId, levelId);
            this.props.addCardsGroups(cardsGroups);
            this.createFeaturesGroups(cardsGroups, levelId);
        }
        if (this.notLevelsPendingToLoad()) {
            this.props.toggleSwitch(ToggleActions.LOADING_LEVEL, false);
            //this.props.toggleSwitch(ToggleActions.METRICS, true);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.levelIds !== prevProps.levelIds) {
            let levelIdsToLoad = this.props.levelIds.filter((selectedlevelId) => {
                return !this.props.loadedLevels.includes(selectedlevelId);
            });
            if (levelIdsToLoad.length) {
                this.props.loadedLevelsChange(levelIdsToLoad);
                this.loadLevels(levelIdsToLoad);
            }
        }
        if (this.props.fullBuilding !== prevProps.fullBuilding
            || this.props.stageIds !== prevProps.stageIds) {
            this.handle3dBuilding();
        }
    }
	  
    render() {
        return (<div></div>);
    }
}

function mapStateToProps( state ){
    return {
        stageIds : state.filters.stageIds,
        levelIds : state.filters.levelIds,
        projectData : state.projectData,
        loadedLevels : state.loadedLevels,
        featuresGroups : state.featuresGroups,
        fullBuilding : state.switches.fullBuilding,
        selectedItem : state.selectedItem,
        projectUsers : state.projectUsers,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
        dayChange : dayChange,
        popupChange : popupChange,
		setProjectData : setProjectData,
		addCardsGroups : addCardsGroups,
        addAreas : addAreas,
		setItemsData : setItemsData,
		setItemProgress : setItemProgress,
        setProjectUsers : setProjectUsers,
        toggleSwitch : toggleSwitch,
        loadedLevelsChange : loadedLevelsChange,
        loadingLevelIdChange : loadingLevelIdChange,
        setQualityProgress : setQualityProgress,
        setUserRole : setUserRole,
        addFeaturesGroups : addFeaturesGroups,
        addMatches : addMatches,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        setCardsGroupsWithHistoricalObservations : setCardsGroupsWithHistoricalObservations,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(PropsManager);